import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { updatePassword } from 'src/app/Interface/login';
import { ApiRequestsService } from 'src/app/services/api-requests.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Component({
  selector: 'app-change-password-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './change-password-modal.component.html',
  styleUrl: './change-password-modal.component.scss'
})
export class ChangePasswordModalComponent implements OnInit {

  // changePassword: updatePassword = {
  //   user_id: 0,
  //   newPassword: '',
  //   confirmPassword: ''
  // }

  showNewPassword = false;
  showConfirmPassword = false;
  passwordsMatch = true;


  constructor(private toaster: ToastrService,
    private activateModal: NgbActiveModal,
    private common: CommonFunctionService,
    private ngbActiveModal: NgbActiveModal,
    private authService: AuthService, private commonApi: ApiRequestsService) { }

  ngOnInit(): void {
    // this.changePassword.user_id = this.common.UserId;
  }
 
 toggleNewPasswordView() {
  this.showNewPassword = !this.showNewPassword;
}


toggleConfirmPasswordView() {
  this.showConfirmPassword = !this.showConfirmPassword;
}

  checkPasswordsMatch() {
    // this.passwordsMatch = this.changePassword.newPassword === this.changePassword.confirmPassword;
  }


  logout() {
    this.authService.logout();
  }

  closeModal() {
    this.ngbActiveModal.close('close');
  }

  // onChangePassword = async () => {
  //   if (this.changePassword.newPassword !== this.changePassword.confirmPassword) {
  //     this.toaster.error('New password and confirm password do not match.', 'Error');
  //     return;
  //   }
  //   const apiUrl = 'users/updatePassword';
  //   const criteriaObj = {
  //     user_id: this.changePassword.user_id,
  //     newPassword: this.changePassword.newPassword
  //   };
  //   try {
  //     const res: any = await this.commonApi.postApiCallReturningPromise(apiUrl, criteriaObj);
  //     if (res['errorCode'] === this.commonApi.NO_ERROR) {
  //       this.toaster.success('Password changed successfully.', 'Success');
  //       this.closeModal();
  //       this.changePassword = {
  //         user_id: 0,
  //         newPassword: '',
  //         confirmPassword: ''
  //       };
  //     } else {
  //       this.toaster.error(res['message'] || 'Error changing password.', 'Error');
  //     }
  //   } catch (error) {
  //     console.error("Error changing password:", error);
  //     this.toaster.error('Error changing password.', 'Error');
  //   }
  // }



  // onChangePassword = async () => {
  //   // Check if new password and confirm password match
  //   if (this.changePassword.newPassword !== this.changePassword.confirmPassword) {
  //     this.toaster.error('New password and confirm password do not match.', 'Error');
  //     return;
  //   }
  
  //   const apiUrl = 'users/updatePassword';
  //   const criteriaObj = {
  //     loginid: this.changePassword.user_id, // Add the login ID to identify the user
  //     oldPassword: this.changePassword.oldPassword, // Include the old password for validation
  //     newPassword: this.changePassword.newPassword
  //   };
  
  //   try {
  //     // Send the request to the backend
  //     const res: any = await this.commonApi.postApiCallReturningPromise(apiUrl, criteriaObj);
  
  //     // Check if the response indicates success
  //     if (res['errorCode'] === this.commonApi.NO_ERROR) {
  //       this.toaster.success('Password changed successfully.', 'Success');
  //       this.closeModal();
  //       this.changePassword = {
  //         loginid: '', // Reset login ID field
  //         oldPassword: '',
  //         newPassword: '',
  //         confirmPassword: ''
  //       };
  //     } else {
  //       this.toaster.error(res['message'] || 'Error changing password.', 'Error');
  //     }
  //   } catch (error) {
  //     console.error("Error changing password:", error);
  //     this.toaster.error('Error changing password.', 'Error');
  //   }
  // }
  
  close() {
    this.activateModal.close('close')
  }
}
